import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PersonIcon from '../../../../assets/customIcons/personIcon';
import { getEntityPrefix } from '../../../../utils/utilFunctions';
import TableTitle from '../../../../components/TableTitle/TableTitle';
import BasicCellText from './BasicCellText';

const CompareReviewColumns = (columnWidths, title) => {
	const [openTooltip, setOpenTooltip] = useState(0);
	const currentPath = window.location.pathname;
	const navigate = useNavigate();

	return [
		{
			field: 'reviewer',
			headerName: 'Reviewer',
			description: 'Reviewer',

			renderCell: (cellValues) => {
				const name = `${cellValues?.formattedValue?.first_name} ${cellValues?.formattedValue?.last_name}`;

				return (
					<BasicCellText
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
						cellValues={{ formattedValue: name }}
						StartIcon={PersonIcon}
						isActive
					/>
				);
			},

			flex: columnWidths.reviewer || 2,
			minWidth: 100,
			resizable: true
		},
		{
			field: 'reviewId',
			headerName: 'Review',
			description: 'Review ID',
			renderCell: (cellValues) => {
				const formID = cellValues.row?.unique_identifier;
				const status = cellValues.row?.status;
				const displayId = `${getEntityPrefix({
					type: 'review-form',
					isInstance: true
				})}${formID}`;
				const titleData = {
					displayId,
					title,
					status,
					entityType: 'Review Form'
				};
				const handleCardClick = () => {
					const newPath = currentPath.replace('compare-reviews', displayId);
					navigate(newPath);
				};
				return <TableTitle titleData={titleData} handleCardClick={handleCardClick} />;
			},

			flex: columnWidths.reviewId || 1,
			minWidth: 100,
			resizable: true
		},
		{
			field: 'completion',
			headerName: 'Completion',
			description: 'Completion',
			renderCell: (cellValues) => {
				const percentage = `${cellValues?.formattedValue}${
					cellValues?.formattedValue?.toString() && '%'
				}`;

				return (
					<BasicCellText
						isDisabled={
							cellValues?.row?.status === 'Submitted' || cellValues?.row?.status === 'Completed'
						}
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
						cellValues={{ formattedValue: percentage }}
						disableIcon={true}
					/>
				);
			},

			flex: columnWidths.completion || 1,
			resizable: true
		},
		{
			field: 'score',
			headerName: 'Score',
			description: 'Score',
			renderCell: (cellValues) => {
				const totalPoints = cellValues.row.total_points ?? 0;
				const userScore = isNaN(parseInt(cellValues.row.score))
					? null
					: parseInt(cellValues.row.score);
				const status = cellValues.row.status;
				const score = status === 'Completed' ? `${userScore}/${totalPoints}` : `0/${totalPoints}`;

				return (
					<BasicCellText
						isDisabled={cellValues?.row?.status === 'Submitted'}
						cellValues={{ formattedValue: score }}
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
					/>
				);
			},
			minWidth: 1,
			flex: columnWidths.score || 1,
			resizable: true
		},
		{
			field: 'comments',
			headerName: 'Overall Comments',
			description: 'Overall Comments',
			renderCell: (cellValues) => (
				<BasicCellText
					isDisabled={cellValues?.row?.status === 'Submitted'}
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
					cellValues={cellValues}
				/>
			),
			flex: columnWidths.comments || 2,
			resizable: true
		},
		{
			field: 'specifics',
			headerName: 'Specifics',
			description: 'Specifics',
			renderCell: (cellValues) => (
				<BasicCellText
					isDisabled={cellValues?.row?.status === 'Submitted'}
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
					cellValues={cellValues}
				/>
			),
			flex: columnWidths.specifics || 2,
			resizable: true
		}
	];
};

export default CompareReviewColumns;
